export default {
  title: 'Reason for changing the site dates',
  body: "Tell us why the site dates are changing. The reason is saved to the site's activity log.",
  rangeLabel: 'Site dates',
  notSet: 'Not set',
  reasonLabel: 'Reason',
  reasonPlaceholder: 'Why are the site dates changing?',
};
